<!--
 * @Description: 课程单条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2026-09-02 11:55:56
-->
<template>
  <div class="jzg_insert">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">课程</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="课程名称/课程号" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="课程分类" v-model="dataGrid.parms.kcflid" clearable filterable @change="initLeftList()">
                <el-option v-for="item in kcflData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable @change="initZhuanYe();bindTable()">
                <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="层次" v-model="dataGrid.parms.ccid" clearable filterable @change="initZhuanYe();bindTable()">
                <el-option v-for="item in ccData" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="pl0 pb0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <el-table-column label="课程号" prop="kch" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="课程名称" prop="kcmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Left END -->
            <el-table-column label="系部" prop="xbmc" align="center" show-overflow-tooltip />
            <el-table-column label="课程分类" prop="kcflmc" align="center" show-overflow-tooltip />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { loadList, loadSelect, closeWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

const currentRow = ref()
const savestudent = () => {
  emits('ReturnData', currentRow.value)
  handleClose()
}
const handleClose = () => {
  emits('update:openDanTiao', false)
}
// 加载 考试形式 下拉框
const kcsxData = ref()

// 加载 课程分类 下拉框
const kcflData = ref()

// 加载 层次 下拉框
const ccData = ref()

// 加载 系部 下拉框
const xbData = ref()

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'kch', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/kecheng/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      ccid: dataGrid.value.parms.ccid,
      xbid: dataGrid.value.parms.xbid,
      order: 'zybh',
      sort: 'asc'
    }
  })
}

watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms = props.row || {}
      loadZiDianSelect('考试形式', kcsxData)
      loadZiDianSelect('课程分类', kcflData)
      loadZiDianSelect('层次', ccData, 'sx', 'asc')
      loadSelect({
        url: '/api/v2/xiaoneijigou/listxibu',
        data: xbData,
        order: 'jgh',
        sort: 'asc'
      })
      bindTable()
      initZhuanYe()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
